module.exports = __webpack_public_path__ + "static/media/5.5b766435.jpeg";